import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <main className="pt-32 pb-24 min-h-[70vh] flex items-center">
      <div className="max-w-2xl mx-auto px-6 text-center">
        <p className="overline">Errore 404</p>
        <h1 className="font-serif text-5xl md:text-6xl mt-4 text-[#0B4A5A]">
          Pagina non trovata
        </h1>
        <p className="mt-6 text-gray-600 leading-relaxed">
          La pagina che stai cercando non esiste o è stata spostata.
        </p>
        <Link to="/" className="btn-primary mt-10 inline-flex">
          <ArrowLeft size={16} /> Torna alla home
        </Link>
      </div>
    </main>
  );
}
